import { SerializableError } from "../utils/serializable-error.js";
var LoginErrors = /* @__PURE__ */ ((LoginErrors2) => {
  LoginErrors2["ACCOUNT_LOCKED_CCI"] = "ACCOUNT_LOCKED_CCI";
  LoginErrors2["ACCOUNT_ACCESS_LOCKED"] = "ACCOUNT_ACCESS_LOCKED";
  LoginErrors2["ACCOUNT_LOCKED"] = "Account Locked";
  LoginErrors2["KR_CI_REQUIRED"] = "KR_CI_REQUIRED";
  return LoginErrors2;
})(LoginErrors || {});
class LoginError extends SerializableError {
  constructor(message, error) {
    var _a, _b;
    super(message);
    this.isUserBlocked = error.isUserBlocked;
    this.isTemporarilyLocked = error.isTemporarilyLocked;
    this.isKMCRequired = error.isKMCRequired;
    this.validationErrors = error.validationErrors || ((_b = (_a = error == null ? void 0 : error.details) == null ? void 0 : _a.details) == null ? void 0 : _b.validationErrors);
    this.details = error.details;
  }
}
export {
  LoginError,
  LoginErrors
};
//# sourceMappingURL=login-types.js.map
